import mainnetPools from '../mainnet'

export default mainnetPools
  .flat()
  .map(pool => ({
    ...pool,
    network: 'local',
  }))
